<template>
  <section>
    <form method="post" @submit.prevent="onSend" novalidate>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ formTitle }}
          </p>
        </header>
        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <form-group name="id" :label="$t('attributes.id')" horizontal>
              {{ form.id }}
            </form-group>
            <form-group name="name" :label="$t('attributes.name')" horizontal>
              <b-input
                v-model="form.name"
                name="name"
                :placeholder="
                  $t('message.please_input') + $t('attributes.name')
                "
                expanded
              ></b-input>
            </form-group>
            <form-group
              name="updated_at"
              :label="$t('attributes.modify_date')"
              horizontal
            >
              {{ formatDateTime(form.updated_at) }}
            </form-group>
            <form-group
              name="created_at"
              :label="$t('attributes.create_date')"
              horizontal
            >
              {{ formatDateTime(form.created_at) }}
            </form-group>
          </form-wrapper>
        </section>
        <footer class="modal-card-foot">
          <b-button class="is-fullwidth" @click="$parent.close()">
            {{ $t('attributes.close') }}
          </b-button>
          <b-button
            :loading="sending"
            type="is-primary"
            class="is-fullwidth"
            native-type="submit"
          >
            {{ isCreate ? $t('attributes.add') : $t('attributes.update') }}
          </b-button>
        </footer>
      </div>
    </form>
  </section>
</template>

<script>
import { maxLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'AttributesForm',
  props: {
    attribute: {
      type: Object,
      required: true
    },
    isCreate: {
      type: Boolean
    }
  },
  data() {
    return {
      labelPosition: 'on-border',
      sending: false,
      form: this.extractFormValues(this.attribute)
    }
  },
  computed: {
    formTitle() {
      let title = !this.isCreate
        ? this.$t('attributes.modify')
        : this.$t('attributes.add')
      title += this.$t('attributes.traveler_type')
      return title
    }
  },
  watch: {
    attribute(newAttribute) {
      this.form = this.extractFormValues(newAttribute)
    }
  },
  validations: {
    form: {
      id: {},
      name: { required, maxLength: maxLength(50) },
      created_at: {},
      updated_at: {}
    }
  },
  methods: {
    extractFormValues(data) {
      return {
        id: data.id,
        name: data.name,
        created_at: data.created_at || '',
        updated_at: data.updated_at || ''
      }
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('send', this.form)
    }
  }
}
</script>
